import { Component, EventEmitter, Input, Output ,OnInit } from "@angular/core"
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthService } from '../service/auth-service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'lsu-login',
    templateUrl: 'login.component.html',
    styleUrls: ['login.component.scss']
})
export class LoginComponent implements OnInit {
    @Input() error: string | null;
    @Output() submitEM = new EventEmitter();
    returnUrl: string;
    constructor(
        private auth: AuthService,
        private router: Router,
        private route: ActivatedRoute) {
    }

    ngOnInit() {
        // reset login status
        //this.authenticationService.logout();

        // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    form: FormGroup = new FormGroup({
        username: new FormControl('', Validators.required),
        password: new FormControl('', [Validators.required, Validators.minLength(5)]),
    });

    public async submit() {
        if (this.form.valid) {
            this.submitEM.emit(this.form.value);
          let x = await  this.auth.login(this.form.get('username').value, this.form.get('password').value)
          this.router.navigate([this.returnUrl]);
        }
    }
}
